module.exports = {
  FRAUD: 'fraude',
  FRAUD_WITH_REFUND: 'fraude_reembolso'
};
